import React, {useCallback, useContext, useEffect, useState} from "react";

import PersistDataGridPro from "../../components/ui/PersistDataGridPro";
import {convertTSDayFirst} from "../../utils/getMomentDate";
import {Button, CircularProgress, Stack} from "@mui/material";
import Grid from "@mui/material/Grid";
import Page from "../ui/Page";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import ConfirmModal from "../ui/ConfirmModal";
import {PageContext, toast} from "@lb/mlib-components";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

export default function Reconcile(props) {

    const title = "Production | Reconcile";

    const pageCtx = useContext(PageContext);

    useEffect(() => pageCtx.updateTitle(title), [pageCtx, title])

    const columns = [
        {field: 'id', type: 'string', disablePadding: false, headerName: 'ID #', width: 120},
        {field: 'sku', type: 'string', disablePadding: false, headerName: 'SKU', width: 120},
        {field: 'lot', type: 'string', disablePadding: false, headerName: 'Lot', width: 120},
        {field: 'qty', type: 'string', disablePadding: false, headerName: 'Quantity', width: 120},
        {field: 'created', disablePadding: false, headerName: 'Created', width: 120, valueFormatter: convertTSDayFirst},
        {
            field: 'note', type: 'string', disablePadding: false, headerName: 'Note', width: 300,
            editable: true,
            renderCell: (params) => (
                <Stack direction={"row-reverse"} alignItems={"center"}>
                    <IconButton sx={{color: '#afaeae'}} size={"small"}><EditIcon fontSize='inherit'/></IconButton>
                    <Typography variant={"body2"}>{params.row.note}</Typography>
                </Stack>),
        },
    ];

    const [loading, setLoading] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

    function loadDocumentFromServer() {
        setLoading(true)

        axios.get(`/export/reconcile`, {
            responseType: 'blob',
            /*headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authCtx.token}`,
            }*/
        }).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.xlsx'); //or any other extension
            document.body.appendChild(link);

            link.click();


        }).catch((error) => {
        }).finally(() => setLoading(false))
    }

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [load, setLoad] = useState(false);

    const onConfirm = useCallback(() => {

        return axios.delete('/reconcile')
            .then((response) => {
                toast.success('Your request has ben successfully sent.');
            }).finally(() => {
                setOpenConfirmationModal(false)
                setLoad(!load)
            })

    }, []);

    return <Page>
        <Backdrop
            sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
            open={loading}
        >
            <CircularProgress color="inherit"/>
        </Backdrop>
        <ConfirmModal open={openConfirmationModal}
                      mainTitle={'Purge'}
                      title="Please confirm this purge."
                      onClose={() => setOpenConfirmationModal(false)}
                      onConfirm={onConfirm}
        />
        <div>
            <div style={{height: "75vh", width: "100%"}}>
                <PersistDataGridPro view="reconcile" columns={columns}
                                    generalLoad={props.load}
                                    searchWidth={10}
                                    load={load}
                >
                    <Grid item xs={2}>
                        <Stack direction={"row"} spacing={1}>
                            <Button variant={"contained"} startIcon={<CleaningServicesIcon/>}
                                    onClick={() => {
                                        setOpenConfirmationModal(true)
                                    }} sx={{p: 2}}>
                                Purge
                            </Button>
                            <Button variant={"outlined"} startIcon={<DownloadIcon/>}
                                    onClick={loadDocumentFromServer} sx={{p: 2}}>
                                Report
                            </Button>
                        </Stack>
                    </Grid>

                </PersistDataGridPro>

            </div>
        </div>
    </Page>
        ;
};
